/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CorsAllowedOriginEntity } from './CorsAllowedOriginEntity';
import {
    CorsAllowedOriginEntityFromJSON,
    CorsAllowedOriginEntityFromJSONTyped,
    CorsAllowedOriginEntityToJSON,
    CorsAllowedOriginEntityToJSONTyped,
} from './CorsAllowedOriginEntity';

/**
 * 
 * @export
 * @interface ListCorsAllowedOriginResult
 */
export interface ListCorsAllowedOriginResult {
    /**
     * 接続元url一覧
     * @type {Array<CorsAllowedOriginEntity>}
     * @memberof ListCorsAllowedOriginResult
     */
    corsAllowedOrigins: Array<CorsAllowedOriginEntity>;
    /**
     * 総数
     * @type {number}
     * @memberof ListCorsAllowedOriginResult
     */
    count: number;
}

/**
 * Check if a given object implements the ListCorsAllowedOriginResult interface.
 */
export function instanceOfListCorsAllowedOriginResult(value: object): value is ListCorsAllowedOriginResult {
    if (!('corsAllowedOrigins' in value) || value['corsAllowedOrigins'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function ListCorsAllowedOriginResultFromJSON(json: any): ListCorsAllowedOriginResult {
    return ListCorsAllowedOriginResultFromJSONTyped(json, false);
}

export function ListCorsAllowedOriginResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListCorsAllowedOriginResult {
    if (json == null) {
        return json;
    }
    return {
        
        'corsAllowedOrigins': ((json['corsAllowedOrigins'] as Array<any>).map(CorsAllowedOriginEntityFromJSON)),
        'count': json['count'],
    };
}

export function ListCorsAllowedOriginResultToJSON(json: any): ListCorsAllowedOriginResult {
    return ListCorsAllowedOriginResultToJSONTyped(json, false);
}

export function ListCorsAllowedOriginResultToJSONTyped(value?: ListCorsAllowedOriginResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'corsAllowedOrigins': ((value['corsAllowedOrigins'] as Array<any>).map(CorsAllowedOriginEntityToJSON)),
        'count': value['count'],
    };
}

